import * as types from './types'
import { ActivityItem, TradeNoteReadPatch, UnreadCounts } from './types'

export const loadTradeNotes = (items: ActivityItem[]) => ({
  type: types.LOAD_TRADE_NOTES,
  payload: items,
})

export const addTradeNote = (item: ActivityItem) => ({
  type: types.ADD_TRADE_NOTE,
  payload: item,
})

export const loadUnreadCounts = (counts: UnreadCounts) => ({
  type: types.LOAD_UNREAD_COUNTS,
  payload: counts,
})

export const applyReadPatches = (patches: TradeNoteReadPatch[]) => ({
  type: types.APPLY_READ_PATCHES,
  payload: patches,
})
